import React from 'react';
import IZebraDetailsCard from './IZebraDetailsCard';
import * as style from './ZebraDetailsCardStyle.module.scss'
import ZebraDetail from './components/ZebraDetail/ZebraDetail';
import { isObject } from '@features/utils/functions';
import { associatedRecord, companyDetails, pitchDetails, spvDetails } from
    '@funds/components/TransactionHistoryTable/components/TransactionHistoryTableRow/ITransactionHistoryTableRow';
import { IGetAnyKey } from '@appInterfaces/general.types';
import { withdrawAccountable } from '@funds/components/InOutHistory/components/InOutHistoryRow/IInOutHistoryRow';
import { classNames } from '@features/utils/reactFunctions';

type TPossibleDetails =
  IGetAnyKey & (companyDetails | spvDetails | pitchDetails | associatedRecord | withdrawAccountable);

const ZebraDetailsCard: React.FunctionComponent<IZebraDetailsCard> = (props) => {
  const { formatValue, labels, data, children } = props;

  const renderDivider = (text: string | number, secondary?: boolean) => {
    const stringedText = text?.toString() ?? "";
    return (
      <div key={text} className={classNames(style.divider, secondary ? style.dividerSecondary : style.dividerPrimary)}>
        <div
          className={classNames(style.label, secondary && style.labelSecondary)}
        >
          {secondary ? stringedText : stringedText.toUpperCase()}
        </div>
      </div>
    );
  };

  const renderValue = (
    label: string,
    value: string | number,
    key: string,
    index: number,
    parent: string,
    autoWidth: boolean = false,
    currency?: string | boolean
  ) => (value || (parent === 'Fee' && label === 'Amount')) &&
      !(value === 'legacy_trust_swift' && label === 'Type') ? (
      <ZebraDetail
        key={key}
        autoWidth={autoWidth}
        value={formatValue(
          label,
          value,
          parent,
          typeof currency === 'string' ? currency : undefined
        )}
        label={label}
        insertHTML={label === 'Info'}
      />
    ) : null;

  const renderDetails = (value: TPossibleDetails, parent: string) => {

    const isStaking = ["StakingFee", "StakingReward"].includes(
      data?.type?.toString()
    );

    return Object.keys(value).map((key, i) => {

      if (isStaking && key === "description") {
        const value = data?.associated_records?.[0]?.description ?? data?.[key];

        return (
          <ZebraDetail
            key={"description"}
            autoWidth={false}
            value={value}
            label={"Description"}
            insertHTML={true}
          />
        )
      }

      return !['slug', (!value.currency) && 'id', (value.network) && 'type', isStaking && "type"].includes(key)
        ? renderValue(
            labels[key],
            value[key],
            key,
            i,
            parent,
            ['name', 'title', 'info'].includes(key),
            key === 'amount' && value.currency
          )
        : null;
    });
  };

  const renderSections = () => {
    return data
      ? Object.keys(data).map((el, i) => {
        if (Array.isArray(data[el])) {
          const multipleObjects = data[el].length > 1;
          const sectionLabel = labels[el].concat(multipleObjects ? 's' : '');
          return (
            <React.Fragment key={`entry${i}`}>
              {renderDivider(sectionLabel)}
                {data[el].map((el: TPossibleDetails, i:number) => {
                  return (
                    <React.Fragment key={`entry${i}inner`}>
                      {multipleObjects && renderDivider(`No.\xa0${i + 1}`, true)}{renderDetails(el, '')}
                    </React.Fragment>
                  );
                })}
            </React.Fragment>
          );
        }

        if (data[el] && typeof data[el] !== 'string' && isObject(data[el])) {
          return (
            <React.Fragment key={i}>
              {renderDivider(labels[el])}{renderDetails(data[el], labels[el])}
            </React.Fragment>
          );
        }

        if (data[el]) {
          return renderValue(labels[el], data[el], el, i, '', isFullWidthColumn(el));
        }

        return null;
      })

      : null;
  };

  const isFullWidthColumn = (el: string) => (
    el === 'type' || el === 'tx_id'
  );

  return (
    <div className={style.zebraDetailsCard} onClick={e => e.stopPropagation()}>
      {renderSections()}
      {children}
    </div>
  );
};

export default ZebraDetailsCard;
